// extracted by mini-css-extract-plugin
export default {"wrapper":"YoutubePreview_wrapper__qLOB2"};